<template lang="pug">
div
  span.text-18.mb-4.mt-4 Выберите иконку
  v-row.mt-1( dense )
    v-col( :cols="(icons.length % 2 !== 0 && i === icons.length - 1) ? 12 : 6" sm="6" v-for="(item, i) in icons" :key="i" )
      div.icon-card( @click="selectIcon(item, i)" :class="{ active: selectedIndex === i }" outlined )
        div.d-flex.align-center
          goal-icon( :title="item.title" :height="32" :width="32")
          span.ml-2.text-14 {{ item.title }}

</template>

<script>
export default {
  name: 'ChooseIcon',

  props: {
    goalTitle: null,
  },

  data() {
    return {
      selectedIndex: null,
      icons: [
        { title: "Игровая приставка", icon: "nintendo.svg" },
        { title: "Велосипед", icon: "bike.svg" },
        { title: "Курс", icon: "course.svg" },
        { title: "Наушники", icon: "headphones.svg" },
        { title: "Коньки", icon: "skates.svg" },
      ],
    };
  },

  mounted() {
    console.log(this.goalTitle);
    
    if(this.goalTitle && this.goalTitle != '') {
      this.selectedIndex = this.icons.findIndex(ic => ic.title == this.goalTitle)
    } else this.selectedIndex = ''
  },

  methods: {
    selectIcon(item, index) {
      this.selectedIndex = index
      this.$emit('selectGoal', item)
    }
  }
};

</script>
<style scoped>
.icon-box {
  width: 32px;
  height: 32px;
  border-radius: 16px;
  background: #0000000D;
}
.icon-card {
  cursor: pointer;
  transition: 0.25s ease;
  border: 2px solid #2962ff;
  border-radius: 12px;
  box-shadow: none;
  height: 56px;
  display: flex;
  padding: 0 12px;
}
.icon-card:hover {
  background-color: #f3f6ff;
}
.icon-card.active {
  background-color: #e8f0ff;
  border-color: #1e88e5;
}

</style>
